import React from 'react';
import { ConfigConsumer } from '../providers';
import { Config } from '../../common/types/config';
import { Omit } from '../../../types/globals';

const withConfig = <T extends WithConfigProps>(
    Component: React.ComponentType<T>
): React.ComponentType<Omit<T, keyof WithConfigProps>> => (props: T) => (
    /* eslint-disable indent */
    /* (Infinite loop between prettier: Delete `····` and eslint/indent: `Expected indentation of 8 spaces but found 4`) */
    /* @todo here we need to change with current country when we have it" */
    <ConfigConsumer>{(config: any) => <Component {...props} config={config} />}</ConfigConsumer>
);
/* eslint-enable indent */

export interface WithConfigProps {
    config: Config;
}

export default withConfig;
